// NotFoundPage.tsx
import { Title1, Text } from "@fluentui/react-components";

const NotFoundPage = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${require('./Assets/whoops.png')})`, 
        backgroundSize: "auto 100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        textAlign: "left",
        padding: "20px 40px",
      }}
    >
      <Title1 style={{ margin: "110px 0 0 70px" }}>Ermm.. Whoops</Title1>
      <Text style={{ margin: "10px 0 0 70px" }}>The page you are looking for does not exist.</Text>
    </div>
  );
};

export default NotFoundPage;
